import React from "react";
import { useAuthContext } from "../context/AuthContext";
import { Link } from "react-router-dom";

const TCPP = () => {
  const { handleTCPP } = useAuthContext();

  return (
    <div className="w-screen h-screen bg-transparent flex justify-center items-center p-[3%] fixed left-0 top-0 right-0 bottom-0 z-50">
      <div className="w-full lg:w-[33%] h-full lg:h-[95%] bg-whiteColor flex flex-col justify-start items-center border rounded-xl lg:rounded-3xl shadow px-[1%] py-[2%] space-y-[3%] overflow-x-hidden overflow-y-scroll scrollbar-hide animate-slideTopToBottom">
        <iframe
          src="https://www.termsfeed.com/live/62824dcd-bd5c-4937-9751-18eee85e545c"
          className="w-full h-full"
          frameBorder="0"
          title="Popup Content"
        />
        <div className="flex space-x-2">
        <h1>Our Patner: </h1>
        <Link to="https://www.lalpathlabs.com/privacy-policy" target="_blank" className="font-normal text-blue-600 underline">
          Dr Lal PathLabs Privacy Policy
        </Link>
        </div>
  
        <button className="btn-primary" onClick={handleTCPP}>
          Close
        </button>
      </div>
    </div>
  );
};

export default TCPP;
